import { render, staticRenderFns } from "./chatMember.vue?vue&type=template&id=681f15f4"
import script from "./chatMember.vue?vue&type=script&lang=js"
export * from "./chatMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports